package com.esoris.kmpmoout.app.platform

actual object Platform {

    actual val isAndroid = false

    actual val isDesktop = false

    actual val isWeb = true
}